module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-dc0e5e85.png";